// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__pcWBd","logo":"MainNavigation_logo__3mTft"};